function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function upgradeMotion(type, name, args) {
  if (type === "enter") {
    return upgradeEnterMotion(name, args);
  }
  if (type === "spring") {
    return upgradeSpringMotion(name, args);
  }
  if (type === "leave") {
    return upgradeExitMotion(name, args);
  }
  return null;
}
function upgradeEnterMotion(name, args) {
  var place = {
    left: "right",
    right: "left",
    up: "down",
    down: "up"
  }[args.direction];
  switch (name) {
    //渐变
    case "fadeIn":
    case "fade":
      {
        return {
          name: "fadeIn",
          args: {}
        };
      }
    case "bounceIn":
    case "bounce":
      {
        return {
          name: "zoomElasticIn",
          args: {}
        };
      }
    //滑入，弹性滑入
    case "slideIn":
    case "slide":
      {
        var bounces = args.bounces,
          direction = args.direction;
        return {
          name: bounces ? "slideElasticIn" : "slideIn",
          args: {
            place: place
          }
        };
      }
    //砸落
    case "dropIn":
    case "drop":
      {
        return {
          name: "dropIn",
          args: {}
        };
      }
    //缩放

    case "zoomEnter":
    case "zoomIn":
    case "zoom":
      {
        var style = args.style,
          intensity = args.intensity;
        if (style === "in") {
          return {
            name: "zoomIn",
            args: {}
          };
        } else {
          return {
            name: "zoomIn",
            args: {}
          };
        }
      }
    //滚入
    case "roll":
      {
        var _direction = args.direction;
        return {
          name: "rollIn",
          args: {
            place: place
          }
        };
      }
    //翻入
    case "flipIn":
    case "flip":
      {
        var _direction2 = args.direction;
        var axis = {
          left: "x",
          right: "x",
          up: "y",
          down: "y"
        }[_direction2];
        return {
          name: "flipIn",
          args: {
            axis: axis !== null && axis !== void 0 ? axis : "x"
          }
        };
      }
    case "rotate":
    case "rotateIn":
    case "rotateByOrigin":
      {
        var origin = args.origin;
        return {
          name: "rotateIn",
          args: {
            origin: origin !== null && origin !== void 0 ? origin : "c"
          }
        };
      }
    default:
      {
        console.warn("animation: ".concat(name, " upgrade failure, is mismatch motion"));
      }
  }
  return null;
}
function upgradeSpringMotion(name, args) {
  switch (name) {
    //闪烁
    case "twinkle":
      {
        return {
          name: "twinkle",
          args: {}
        };
      }
    //摇摆
    case "swing":
      {
        return {
          name: "swing",
          args: {}
        };
      }
    //晃动
    case "wobble":
      {
        return {
          name: "wobble",
          args: {}
        };
      }
    //抖动
    case "shake":
      {
        return {
          name: "shake",
          args: {}
        };
      }
    //旋转
    case "rotate360":
      {
        return {
          name: "rotate360",
          args: {}
        };
      }
    //缩放使用心跳动画代替
    case "zoom":
      {
        return {
          name: "heartbeat",
          args: {}
        };
      }
    //心跳
    case "beat":
      {
        return {
          name: "heartbeat",
          args: {}
        };
      }
    default:
      {
        console.warn("animation: ".concat(name, " upgrade failure, is mismatch motion"));
      }
  }
  return null;
}
function upgradeExitMotion(name, args) {
  var place = {
    left: "left",
    right: "right",
    up: "up",
    down: "down"
  }[args.direction];
  switch (name) {
    //渐变
    case "fade":
      {
        return {
          name: "fadeOut",
          args: {}
        };
      }
    // case 'bounce': {
    //   return {
    //     name: 'zoomElasticIn',
    //     args: {
    //
    //     }
    //   }
    // }

    // //砸落
    // case 'drop': {
    //   return {
    //     name: 'dropIn',
    //     args: {
    //
    //     }
    //   }
    // }
    //缩放
    case "zoomLeave":
    case "zoom":
      {
        var style = args.style,
          intensity = args.intensity;
        return {
          name: "zoomOut",
          args: {}
        };
      }
    //滑入，弹性滑入
    case "slideOut":
    case "slide":
      {
        var bounces = args.bounces,
          direction = args.direction;
        return {
          name: bounces ? "slideElasticOut" : "slideOut",
          args: {
            place: place
          }
        };
      }
    //翻出
    case "flipOut":
    case "flip":
      {
        var _direction3 = args.direction;
        var axis = {
          left: "x",
          right: "x",
          up: "y",
          down: "y"
        }[_direction3];
        return {
          name: "flipOut",
          args: {
            axis: axis !== null && axis !== void 0 ? axis : "x"
          }
        };
      }

    //滚入
    case "roll":
      {
        var _direction4 = args.direction;
        return {
          name: "rollOut",
          args: {
            place: place
          }
        };
      }
    default:
      {
        console.warn("animation: ".concat(name, " upgrade failure, is mismatch motion"));
      }
  }
  return null;
}
export function upgradeAnimation(input) {
  //若有when代表是新版的
  if (input.when) {
    return input;
  }
  var type = input.type,
    name = input.name,
    args = input.args,
    duration = input.duration,
    delay = input.delay,
    iterations = input.iterations;
  var motion = upgradeMotion(type, name, args);
  if (!motion) {
    console.warn("animation: ".concat(type, "-").concat(name, " upgrade failure"));
    return null;
  }
  var when = {
    enter: "enter",
    spring: "spring",
    leave: "exit"
  }[type];
  return _objectSpread(_objectSpread({}, motion), {}, {
    when: when,
    duration: duration,
    delay: delay,
    iterations: iterations
  });
}